export default __webpack_public_path__ + "static/media/Animations_Circle11.813222f9.svg";